import React, { useState } from "react";
import {
  AppFileUploader,
  AppInput,
  AppModal,
  AppRemixIcon,
  AppTextArea,
  AppNotificationAlert,
} from "@/layout/AppComponents";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useParams } from "react-router-dom";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../../../components/helpers/Translator";
import { axiosPath } from "../../../../../../routing/helpers/router";
import minions from "../../../../../../minions/minions";

const RequestForm = () => {
  const { moduleBridgeHex, plantHex } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOnSubmit = async (values) => {
    if (isLoading) return;
    setIsLoading(true);
    await axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_evaluation_plantRequest"),
        minions.forms.toFormData({ ...values, moduleBridgeHex, plantHex }),
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((response) => {
        setShowModal(false);
        AppNotificationAlert({
          title: "OK",
          message: response.data.message,
          type: response.data.type,
          position: "top-right",
          duration: 3000,
        });
      })
      .catch(() => {
        AppNotificationAlert({
          title: "Error",
          message: "error",
          type: "danger",
          position: "top-right",
          duration: 3000,
        });
      })
      .finally(() => setIsLoading(false));
  };

  // < FORM SCHEMA
  const validationSchema = Yup.object().shape({
    subject: Yup.string().required(
      ReactDOMServer.renderToString(<Translator file="user" name="user.required" />)
    ),
    cc: Yup.string(),
    message: Yup.string(),
  });
  // < FORM SCHEMA

  return (
    <>
      <li
        className="btn btn-sm btn-info mr-2 mb-1"
        onClick={() => setShowModal(true)}
      >
        <Translator
          file="module-legalCompliance"
          name="module.lc.plant-info.request"
        />
      </li>
      <AppModal
        title={ReactDOMServer.renderToString(
          <Translator
            file="module-legalCompliance"
            name="module.lc.plant-info.request"
          />
        )}
        show={showModal}
        onClose={() => setShowModal(false)}
      >
        <Formik
          initialValues={{
            subject: "",
            cc: "",
            message: "",
            file: null,
          }}
          validationSchema={validationSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={handleOnSubmit}
        >
          {({ handleSubmit, values, setFieldValue, errors }) => (
            <>
              <div className="row">
                <div className="col-lg-12">
                  <AppInput
                    title={
                      <Translator
                        file="module-legalCompliance"
                        name="module.lc.plant-info.request.subject"
                      />
                    }
                    icon={<AppRemixIcon icon="double-quotes-l" noVariants />}
                    value={values.subject}
                    onChange={(opt) => setFieldValue("subject", opt)}
                    error={errors.subject}
                    isClearable
                  />
                </div>
                <div className="col-lg-12">
                  <AppInput
                    title="CC"
                    icon={<AppRemixIcon icon="share-forward" />}
                    value={values.cc}
                    onChange={(opt) => setFieldValue("cc", opt)}
                    error={errors.cc}
                    isClearable
                  />
                </div>
                <div className="col-lg-12">
                  <AppTextArea
                    title={
                      <Translator
                        file="module-legalCompliance"
                        name="module.lc.plant-info.request.message"
                      />
                    }
                    icon={<AppRemixIcon icon="mail" />}
                    onChange={(opt) => setFieldValue("message", opt)}
                    value={values.message}
                    error={errors.message}
                  />
                </div>
                <div className="col-lg-12">
                  <AppFileUploader
                    placeholder={
                      values.file ? (
                        values.file[0].name
                      ) : (
                        <Translator file="general" name="select.a.file" />
                      )
                    }
                    onChange={(opt) => setFieldValue("file", opt)}
                    btnText={<Translator file="general" name="search..." />}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12 mt-4">
                  <span
                    className="btn btn-outline-light"
                    onClick={() => setShowModal(false)}
                  >
                    <Translator file="user" name="user.cancel" />
                  </span>
                  <span
                    className={`btn btn-success float-right ${
                      isLoading ? "disabled" : ""
                    }`}
                    onClick={handleSubmit}
                  >
                    <Translator
                      file="module-legalCompliance"
                      name="module.lc.plant-info.request.send"
                    />
                  </span>
                </div>
              </div>
            </>
          )}
        </Formik>
      </AppModal>
    </>
  );
};

export default RequestForm;
